(function () {
  var root = document.querySelector('[data-cw]');
  if (!root) return;
  var panel = root.querySelector('.cw__panel'), fab = root.querySelector('[data-cw-open]');
  var log = root.querySelector('[data-cw-log]'), form = root.querySelector('[data-cw-form]'), input = root.querySelector('[data-cw-input]');
  var chips = root.querySelector('[data-cw-chips]'), sendBtn = root.querySelector('.cw__send');
  var endpoint = root.getAttribute('data-endpoint'), email = root.getAttribute('data-email') || 'info@swedestthing.com';
  var KEY = 'cw_chat_v1', history = [], busy = false, opener = null;
  root.hidden = false;

  // On phones, sit the chat button just above whatever is fixed to the bottom (free-shipping bar, sticky Add to cart bar).
  // Measured, so it is right on every page and when those bars appear or disappear.
  function lift() {
    if (!matchMedia('(max-width: 640px)').matches) { fab.style.removeProperty('bottom'); return; }
    var top = window.innerHeight;
    document.querySelectorAll('.ms, .cp__sticky, .c3__tray').forEach(function (e) {
      if (e.hidden) return;
      var r = e.getBoundingClientRect(), cs = getComputedStyle(e);
      if (r.height > 0 && cs.position === 'fixed' && cs.visibility !== 'hidden' && r.bottom > window.innerHeight - 30) top = Math.min(top, r.top);
    });
    if (top < window.innerHeight) fab.style.setProperty('bottom', (window.innerHeight - top + 12 + 62) + 'px', 'important'); else fab.style.removeProperty('bottom');
  }
  lift(); setInterval(lift, 700);
  window.addEventListener('resize', lift); window.addEventListener('scroll', lift, { passive: true });

  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(history.slice(-12))); } catch (e) { /* chat still works without it */ } }
  function load() { try { var h = JSON.parse(sessionStorage.getItem(KEY) || '[]'); return Array.isArray(h) ? h : []; } catch (e) { return []; } }

  function linkify(text) {
    var safe = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return safe.replace(/(^|[\s(])(\/(?:pages|collections|products|blogs|policies)\/[A-Za-z0-9\-_\/?=&;%.]*[A-Za-z0-9\/])/g, '$1<a href="$2">$2</a>')
               .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  }
  function add(role, text, extra) {
    var d = document.createElement('div');
    d.className = 'cw__msg cw__msg--' + (role === 'user' ? 'me' : 'bot') + (extra ? ' ' + extra : '');
    if (role === 'user') d.textContent = text; else d.innerHTML = linkify(text);
    log.appendChild(d); log.scrollTop = log.scrollHeight; return d;
  }
  function addMail() {
    var a = document.createElement('a'); a.className = 'cw__mail'; a.href = 'mailto:' + email + '?subject=' + encodeURIComponent('Question from the website');
    a.textContent = 'Email us'; log.appendChild(a); log.scrollTop = log.scrollHeight;
  }
  function greet() { add('assistant', "Hej! I'm the Swedest Thing assistant. Ask me about shipping, the Pick-n-Mix machine, deals or which mix to try."); }

  function open() {
    if (!panel.hidden) return;
    opener = document.activeElement; panel.hidden = false; fab.hidden = true;
    if (matchMedia('(max-width: 640px)').matches) document.documentElement.classList.add('cw-lock');
    if (!log.children.length) { var h = load(); if (h.length) { history = h; h.forEach(function (m) { add(m.role, m.content); }); chips.hidden = true; } else greet(); }
    setTimeout(function () { input.focus({ preventScroll: true }); }, 150);
  }
  function close() {
    panel.hidden = true; fab.hidden = false; document.documentElement.classList.remove('cw-lock');
    if (opener && opener.focus) try { opener.focus(); } catch (e) { /* ignore */ }
  }
  // keep the panel above the on-screen keyboard on phones
  if (window.visualViewport) {
    var fit = function () { panel.style.setProperty('--cw-vh', window.visualViewport.height + 'px'); log.scrollTop = log.scrollHeight; };
    window.visualViewport.addEventListener('resize', fit); window.visualViewport.addEventListener('scroll', fit); fit();
  }
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cw-open]')) open();
    else if (e.target.closest('[data-cw-close]')) close();
    var c = e.target.closest('[data-cw-chip]'); if (c) send(c.getAttribute('data-cw-chip'));
  });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-chat-open]')) { e.preventDefault(); open(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });

  function send(text) {
    text = (text || '').trim(); if (!text || busy) return;
    busy = true; sendBtn.disabled = true; chips.hidden = true; input.value = '';
    add('user', text); history.push({ role: 'user', content: text });
    var typing = add('assistant', '...', 'cw__msg--typing');
    var ctrl = new AbortController(), t = setTimeout(function () { ctrl.abort(); }, 25000);
    fetch(endpoint.replace(/\/$/, '') + '/chat', { method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: ctrl.signal, body: JSON.stringify({ messages: history.slice(-12), page: location.pathname }) })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) {
        typing.remove();
        var reply = d && d.reply ? d.reply : 'Sorry, I cannot answer right now. Please email ' + email + '.';
        add('assistant', reply); history.push({ role: 'assistant', content: reply }); save();
        if (!d || !d.reply || d.handoff) addMail();
      })
      .catch(function () { typing.remove(); add('assistant', 'Sorry, I cannot reach the assistant right now. Please email ' + email + ' and we will help.'); addMail(); })
      .then(function () { clearTimeout(t); busy = false; sendBtn.disabled = false; if (!matchMedia('(max-width: 640px)').matches) input.focus(); });
  }
  form.addEventListener('submit', function (e) { e.preventDefault(); send(input.value); });
})();
